import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GalleryListPage } from './gallery-list.component';
import { authGuard } from '@guards/auth.guard';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'galleries',
    component: GalleryListPage,
    canActivate: [authGuard, hasRoleGuard(null, ['read_galleries'])],
    data: {
      title: "Lista de galerías"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GalleryListPageRoutingModule { }
